import { faCreditCard } from '@fortawesome/pro-solid-svg-icons';
import {
  GenericSelectorModalConfig,
  GenericNodeComponentConfig,
} from '../shared';

/**
 * PayerType item interface for ui_metadata storage
 */
export interface PayerTypeItem {
  id: string;
  displayLabel: string;
  name: string;
}

/**
 * Transform API response to PayerTypeItem format
 */
export const transformPayerType = (apiItem: { name: string }): PayerTypeItem => ({
  id: apiItem.name,
  displayLabel: apiItem.name,
  name: apiItem.name,
});

/**
 * Modal configuration for PayerType selector
 */
export const payerTypeModalConfig: GenericSelectorModalConfig<PayerTypeItem> = {
  title: 'Select Payer Types',
  searchPlaceholder: 'Search payer types...',
  emptyStateIcon: faCreditCard,
  emptyStateMessage: 'No payer types selected',
  noResultsMessage: (searchTerm) => `No payer types found for "${searchTerm}"`,
  colorTheme: 'pink',
  selectionMode: 'multiple',
  showConnectorToggle: true,
  defaultConnector: 'ANY',
  getItemLabel: (item) => item.name,
  getItemKey: (item) => item.id,
  isItemSelected: (item, selectedItems) =>
    selectedItems.some((s) => s.id === item.id),
  itemLabel: 'payer type',
  itemLabelPlural: 'payer types',
};

/**
 * Node display configuration for PayerType
 */
export const payerTypeNodeConfig: GenericNodeComponentConfig<PayerTypeItem> = {
  colorTheme: 'pink',
  getItemLabel: (item) => item.name,
  getItemKey: (item) => item.id,
  maxVisibleItems: 2,
  showConnectorLabel: true,
};
